module.exports = __webpack_public_path__ + "static/media/home-hero--bg-france.fbd7b5ec.jpg";